import axios from "axios";


const apiAlgos = (fillVar, ready) => {
    axios.get("https://nyu.danielwalt.io/api/algos")
        .then((resp) => {
            fillVar.value = resp.data;
            ready.value = true;
        })
        .catch((err) => {
            console.log(err);
            fillVar.value = [{}];
            ready.value = false;
        });
}

export {apiAlgos}